import { createContext, useEffect, useReducer, useState } from "react";

export const AuthContext = createContext();

export const authReducer = (state, action) => {
  switch (action.type) {
    case "LOGIN":
      return { user: action.payload, expired: false };
    case "UPDATE":
      return { user: action.payload, expired: false };
    case "EXPIRE":
      return { user: null, expired: true };
    case "LOGOUT":
      return { user: null };
    default:
      return state;
  }
};

export const AuthContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(authReducer, {
    user: null,
  });
  const [userLoading, setUserLoading] = useState(true);
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      dispatch({ type: "LOGIN", payload: user });
    }
    setUserLoading(false);
  }, []);

  return (
    <AuthContext.Provider value={{ ...state, userLoading, dispatch }}>
      {children}
    </AuthContext.Provider>
  );
};
